import { render } from "./TheRate.vue?vue&type=template&id=4172bcb1"
import script from "./TheRate.vue?vue&type=script&lang=js"
export * from "./TheRate.vue?vue&type=script&lang=js"

import "./TheRate.vue?vue&type=style&index=0&id=4172bcb1&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__